/**
 *  赋值文本
 * @param content
 */
const doCopy = (content) => {
    const input = document.createElement('input');
    input.setAttribute('value', content);
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
}

/**
 * @param time
 * @param format
 * @description格式化时间
 * */
const formatTime = (time, format) => {
  if (time) {
    let t = new Date(time)
    let tf = function (i) {
      return (i < 10 ? '0' : '') + i
    }
    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
      switch (a) {
        case 'yyyy':
          return tf(t.getFullYear())
        case 'MM':
          return tf(t.getMonth() + 1)
        case 'mm':
          return tf(t.getMinutes())
        case 'dd':
          return tf(t.getDate())
        case 'HH':
          return tf(t.getHours())
        case 'ss':
          return tf(t.getSeconds())
      }
    })
  } else {
    return '---'
  }
};

/**
 * 手机号码脱敏
 * @param str
 * @returns {string}
 */
const phoneEncryption = (str) => {
  if (!str) return;
  let newStr = str.substring(0, 3);
  let newStrs = str.substring(str.length, str.length - 4);
  newStr = newStr + "****" + newStrs;
  return newStr;
};

/**
 * 姓名脱敏
 * @param str
 */
const nameHide = (str) => {
  if (!str) return ;
  const arr = str.split('');
  return arr[0] + '**' + arr[arr.length - 1];
}

/**
 * 保留两位小数
 * @param num
 * @returns {string}
 */
const decimal = (num) => {
  const _num = Number(num);
  if (isNaN(_num)) return '0.00';
  return _num.toFixed(2);
};

/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
  let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-'
  let M =
    (date.getMonth() + 1 < 10 ?
      '0' + (date.getMonth() + 1) :
      date.getMonth() + 1) + '-'
  let D =
    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  let h =
    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  let m =
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
    ':'
  let s =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return Y + M + D + h + m + s
};


/**
 * //获取当前时间
 */
const getDateTimeNow = () => {
  var time = new Date();
  var day = ("0" + time.getDate()).slice(-2)
  var month = ("0" + (time.getMonth() + 1)).slice(-2)

  var hour = ("0" + time.getHours()).slice(-2)
  var minute = ("0" + time.getMinutes()).slice(-2)
  var second = ("0" + time.getSeconds()).slice(-2)

  var today = time.getFullYear() + "-" + (month) + "-" + (day)
  // var today = time.getFullYear() + "-" + (month) + "-" + (day) + " " + (hour) + ":" + (minute) + ":" + second
  return today
}


/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
  let date = new Date();
  date.setDate(date.getDate() + day);
  document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
  let reg = RegExp(name + '=([^;]+)');
  let arr = document.cookie.match(reg);
  if (arr) {
    return arr[1];
  } else {
    return '';
  }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
  setCookie(name, null, -1);
};

function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  };
  return null;
}


export {
  getQueryString,
  formatTime,
  decimal,
  phoneEncryption,
  timestampToTime,
  setStore,
  getStore,
  removeStore,
  setCookie,
  getCookie,
  delCookie,
  getDateTimeNow,
  doCopy,
  nameHide
}



// WEBPACK FOOTER //
// ./src/utils/util.js